module.exports = __webpack_public_path__ + "img/order-tab-pending.5de6793c.png";